import { Registry } from '@react-registry'

export const withVideo = (editor) => {
  const { isVoid } = editor

  editor.isVoid = (element) => {
    return element.type === 'video' ? true : isVoid(element);
  }

  return editor
}

Registry.register(withVideo, { id: 'withVideo', registry: 'plugin' })